import React, { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import {
  CONSTANTS,
  COOKIE,
  MEDIA_TYPES,
  SUMMARY_ALLOWED_CLIENTS,
} from "../../../constants/app-constant";
import Initials from "../../Shared/Initials";
import {
  escapeString,
  getCommaSeparatedNumbers,
  isLoggedIn,
} from "../../../utility/common-methods";
import { ImagePreview } from "../ImagePreview";
import { PDFImageViewer } from "../PDFImageViewer";
import { FEED_DETAILS } from "../../../constants/route-constants";
import { envConfig } from "../../../constants/api-endpoint";
import NextPrevArrows from "./NextPrevArrows";
import ArticleTags from "./ArticleTags";
import DownloadFeeds from "./DownloadFeeds";
import { Button } from "react-bootstrap";
import ButtonGroup from "rsuite/ButtonGroup";
import {
  ShareIcon,
  FavoriteIcon,
  MenuIcon,
} from "../../../components/Icons/icons.component";
import ShareArticle from "../../Shared/ShareArticle";
import PopoverContent from "./PopperContent.jsx";
import { getCookie } from "../../../utility/cookieProvider";
import { useSelector } from "react-redux";
import {
  FacebookShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  FacebookIcon
} from "react-share"; 
import DOMPurify from 'dompurify';
const { DATA_NOT_FOUND, EMPTY_STRING, SUMMARY } = CONSTANTS;
const [PDF, IMG, TEXT, HIDE_DATA, SHOW_DATA, SUMMERY] = [0, 1, 2, "0", "1", 3];

export default function SingleNews({
  key,
  isPrint,
  isOnline,
  newsDetails,
  handleImageZoom,
  news,
  clientId,
  selectedArticleGrouped = [],
  forEmbedArticles,
  keywordsList,
  articleIdList,
  isNewsDetailsMain,
  downloadParams,
  enableSelectMode = true,
  isSelected = false,
  onFeedSelect,
  publication_type_id,
}) {
  const [viewText, setViewText] = useState(true);
  const [imgType, setImageType] = useState(IMG);
  const [isLoading, setIsLoading] = useState(false);
  const clientState = useSelector((state) => state.clientReducer) || {};
  const { result } = clientState.isAuth;
  const [articlenewslink,setarticlenewslink] = useState(news.website_url)
  const [articletitle,setarticletitle] = useState(news.headline)
  const {
    ccm,
    publish_date,
    publish_datetime,
    mav,
    suppliment,
    website_category,
    category,
    publication,
    headline,
    circlation,
    website_type,
    edition,
    news_type,
    language,
    images,
    page_no,
    website_url,
    word_count,
    website_global_rank,
    time_on_site,
    position,
    website_category_rank,
    advertising,
    location_id,
    imagebaseurl,
    CONTENT,
    source,
    source_name,
    reportor,
    client_id,
    article_id,
    entity_id,
    hide_metadata_details,
    show_sqcm_pdf = HIDE_DATA,
    sqcm_val,
    is_text_view = SHOW_DATA,
    showImages = SHOW_DATA,
    is_show_similar_web = HIDE_DATA,
    alexa_details,
    photo,
    top_image,
    other_edition_url_html,
    page_per_visits,
    website_country_rank,
    entity_detail,
    publication_logo,
    Forclient_id,
    unique_desktop_visitors,
    unique_mobile_visitors,
    monthly_visitors,
    summary,
    publication_type,
    id,
    opoint_details,
    height,
    width,
    newsletter_article_url,
    monthly_visitor,
    updated_values
  } = news || {};
  console.log('news', news)
  const correctedCCM = ccm;
  const handleArticleClick = (e, article) => {
    e.preventDefault();
    e.stopPropagation();
    let correctedId = article_id;
    if (article) {
      correctedId = article.article_id;
    }
    if (articleIdList)
      localStorage.setItem("articleIdList", JSON.stringify(articleIdList));

    if (isPrint) {
      window.open(
        `https://${window.location.host}${FEED_DETAILS}/${
          MEDIA_TYPES.PRINT_MV
        }/${client_id || Forclient_id}-${correctedId}-${entity_id}`,
        "_blank"
      );
    }

    if (isOnline) {
      if (newsDetails || website_type === "International") {
        window.open(website_url);
      } else {
        window.open(
          `https://${window.location.host}${FEED_DETAILS}/${
            MEDIA_TYPES.ONLINE_MV
          }/${client_id || Forclient_id}-${correctedId}-${entity_id}`,
          "_blank"
        );
      }
    }
  };

  const getArticleImage = (image_url = EMPTY_STRING, getAllImages) => {
    try {
      const isArray = image_url.indexOf(",") !== -1;
      if (!isArray) {
        if (!getAllImages) {
          return image_url;
        }
        return Array(image_url);
      } else {
        const imgTokens = image_url.split(",");
        if (!getAllImages) {
          return imgTokens[0];
        }
        return imgTokens;
      }
    } catch (e) {
      return EMPTY_STRING;
    }
  };

  const articleImages =
    isPrint || newsDetails
      ? getArticleImage(images, true)
      : getArticleImage(images, false);

  const formatImageUrl = (src, useHttps, getPdf) => {
    try {
      const baseURL =
        process.env.REACT_APP_FEEDS_BASE_URL ||
        envConfig.ARTICLES_IMAGE_BASE_URL;
      let tempStr = `${src}`;
      if (useHttps) {
        let tempStr = `${src}`;
        if (getPdf) {
          tempStr = tempStr.replace(".jpg", ".pdf");
        }
        return tempStr;
      }
      return tempStr;
    } catch (e) {
      return src;
    }
  };

  const [newsContent, setNewsContent] = useState("");
  const [highlightedKeyword, setHighlightedKeyword] = useState("");

  useEffect(() => {
    setNewsContent(document.querySelector("#newsContent"));
  }, []);

  const keywordClick = (e, { entity_name, keywords }) => {
    keywords = Object.values(keywords);
    let contentString = newsContent.textContent;
    const regex = new RegExp(keywords.join("|"), "gi");

    if (highlightedKeyword !== entity_name) {
      setHighlightedKeyword(entity_name);
      contentString = contentString.replace(regex, function replace(match) {
        return "<span className='highlight-text'>" + match + "</span>";
      });
      newsContent.innerHTML = contentString;
    } else {
      setHighlightedKeyword("");
      newsContent.innerHTML = newsContent.textContent;
    }
  };

  const renderOnlineDetails = () => {
    const correctedTOS = time_on_site && parseInt(time_on_site, 10);
    const correctedPPV = page_per_visits && Number(page_per_visits).toFixed(2);
    return (
      <>
        <div className="detailsMetaTagWrap">
          <p>
            <label>Entity :</label>{" "}
            <span>{entity_detail ? entity_detail.entity_name : ""}</span>
          </p>
          <p>
            <label>Website :</label>{" "}
            <span className="link" onClick={() => window.open(website_url)}>
              {publication || DATA_NOT_FOUND}
            </span>
          </p>
          <p>
            <label>Source :</label> <span>{source_name || DATA_NOT_FOUND}</span>
          </p>
          <p>
            <label>Word Count :</label>{" "}
            <span>
              {getCommaSeparatedNumbers(word_count) || DATA_NOT_FOUND}
            </span>
          </p>
          <PopoverContent
            showAlexaDetails={is_show_similar_web !== SHOW_DATA}
            correctedTOS={correctedTOS}
            correctedCCM={correctedCCM}
            website_global_rank={website_global_rank}
            news_type={news_type}
            advertising={advertising}
            position={position}
            alexa_details={alexa_details}
            page_per_visits={correctedPPV}
            website_category_rank={website_category_rank}
            language={language}
            isOnline={isOnline}
            location_id={location_id}
            website_category={website_category}
            website_country_rank={website_country_rank}
            unique_desktop_visitors={unique_desktop_visitors}
            unique_mobile_visitors={unique_mobile_visitors}
            monthly_visitors={monthly_visitors}
            monthly_visitor={monthly_visitor}
            opoint_details={opoint_details}
            publish_datetime={publish_datetime}
            updated_values={updated_values}
          />
        </div>
        {SUMMARY_ALLOWED_CLIENTS.includes(Number(clientId)) && updated_values?.length && updated_values[0].summary && updated_values[0].summary != ""?
          <div className="summaryDiv">
            <label 
              // style={{fontWeight:'bolder',color: '#938fa9',fontSize: 12,fontFamily: "Manrope-Regular"}}
            >
              {SUMMARY} :- 
            </label> 
            <br />
            <span 
              // style={{color: '#333333',fontSize: 12,fontFamily: "Manrope-Regular"}}
            >&nbsp;{updated_values[0].summary || DATA_NOT_FOUND}</span>
          </div>
        :""}
        {is_text_view === SHOW_DATA && (
          <>
            <div className="linkViewTextBtnWraps">
              {viewText && (
                <div className="viewTextWrap">
                  {photo === SHOW_DATA && top_image && (
                    <ImagePreview
                      imgSrcArray={Array(top_image)}
                      handleImageZoom={handleImageZoom}
                      singleImage
                    />
                  )}
                  {/* <p id="newsContent">{`${escapeString(CONTENT)}`}</p> */}
                  <p id="newsContent">
                    {SUMMARY_ALLOWED_CLIENTS.includes(Number(clientId))?escapeString(CONTENT,news.plain_matched_keyword)
                      .split(/\n/)
                      .map((str) => (
                        <p
                          style={{
                            // textIndent: "25px",
                            textAlignLast: "left",
                            textAlign: "start",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(str),
                          }}                    
                        >
                        </p>
                      ))
                    :escapeString(CONTENT)
                    .split(/\n/)
                    .map((str) => (
                      <p
                        style={{
                          textIndent: "25px",
                          textAlignLast: "left",
                          textAlign: "start",
                        }}
                      >
                        {str}
                      </p>
                    ))}
                  </p>
                  {keywordsList.length ? (
                    <div id="keywords" className="keywordsWrap">
                      <label>Tags: </label>
                      <div className="keywordsListing">
                        {keywordsList.map((item) => {
                          return (
                            <span
                              onClick={(e) => keywordClick(e, item)}
                              className="content-keyword"
                            >
                              {item.entity_name}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          </>
        )}
      </>
    );
  };

  const renderPrintDetails = () => {
    return (
      <>
        <div className="editionTabWrap">
          <nav class="nav card-header-tabs nav-tabs">
            <span className="nav-item editionTitle">Edition :</span>{" "}
            <div className="navLinksWrap">{renderEditionDetails()}</div>
          </nav>
        </div>
        <p>
          <label>Entity :</label>{" "}
          <span>{entity_detail ? entity_detail.entity_name : ""}</span>
        </p>
        <p>
          <label>Publication :</label>{" "}
          <span>{publication || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Source :</label> <span>{(reportor) || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Supplement :</label>{" "}
          <span>{suppliment || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Language :</label> <span>{language || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Page :</label> <span>{page_no || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Circulation :</label>{" "}
          <span>{circlation || DATA_NOT_FOUND}</span>
        </p>
        <p>
          {show_sqcm_pdf === SHOW_DATA ? (
            <>
              <label>SQCM :</label> <span>{sqcm_val || DATA_NOT_FOUND}</span>
            </>
          ) : (
            <>
              <label>CCM :</label>{" "}
              <span>{correctedCCM || DATA_NOT_FOUND}</span>
            </>
          )}
        </p>
        <p>
          <label>Mav :</label> <span>{mav || DATA_NOT_FOUND}</span>
        </p>
      </>
    );
  };

  const renderEditionDetails = () => {
    if (isNewsDetailsMain && other_edition_url_html) {
      const { host, protocol } = window.location;
      const newHost = `${protocol}//${host}`;
      let newUrls = other_edition_url_html
        .replaceAll("href", 'class="nav-item nav-link" href')
        .replaceAll(" | ", "");
      let activeEdition = newUrls.match(
        /^[\*\s\w]*|[^\>]+(?=\<a )|[\*\s\w]*$/gs
      );
      if (activeEdition && activeEdition.length > 0) {
        const str = activeEdition.find((i) => i);
        newUrls = newUrls.replace(
          str,
          `<span class="nav-item active">${str}</span>`
        );
      }
      return <>{ReactHtmlParser(newUrls)}</>;
    }

    const showSingleEdition =
      (Array.isArray(selectedArticleGrouped) &&
        selectedArticleGrouped.length == 0) ||
      isOnline;
    return (
      <p className="editionList">
        <label>Edition: </label>{" "}
        {showSingleEdition ? (
          <span className="link editions activeEdition">
            {edition || (isOnline ? "Online Web" : "Print")}
          </span>
        ) : (
          selectedArticleGrouped.map((el, index) => {
            const isActive = newsDetails && el.edition === news.edition;
            return (
              <>
                <span
                  onClick={(e) => handleArticleClick(e, el)}
                  className={`editions ${isActive ? "activeEdition" : ""}`}
                >
                  {el.edition || DATA_NOT_FOUND}
                </span>
                {index < selectedArticleGrouped.length - 1}
              </>
            );
          })
        )}
      </p>
    );
  };

  const shareParams = {
    article_id: id,
    edition,
    entity_id: entity_detail.id,
    entity_name: entity_detail.entity_name,
    entity_type: entity_detail.entity_type,
    headline,
    language,
    publication,
    publication_type,
    source,
    summary: CONTENT,
    publish_date,
    link: newsletter_article_url,
    page_nos: page_no,
  };

  const showPageNo = isPrint
    ? newsDetails || selectedArticleGrouped.length <= 1
    : false;

  let detailsClass = "singleNewsItem";

  if (newsDetails) {
    if (isPrint) {
      detailsClass = "newsDetailsWrap printDetailsWrap feedDetailsWrap";
    }
    if (isOnline) {
      detailsClass = "newsDetailsWrap onlineDetailsWrap feedDetailsWrap";
    }
  }
  return (
    <>
      {enableSelectMode && !newsDetails && (
        <label className="inputWrap">
          <input
            type="checkbox"
            onChange={(e) =>
              onFeedSelect && onFeedSelect(e.target.checked, news)
            }
          />
          <span className="checkmark"></span>
        </label>
      )}
      <div
        onClick={(e) => (!newsDetails ? handleArticleClick(e) : null)}
        className={`${detailsClass} clearfix`}
      >
        <div className="newsItemTopWrap">
          <div className="newsItemTop">
            <div className="nitLeft">
              {/* <Initials name={publication} /> */}
              {/* <h2 className="publication">{publication || DATA_NOT_FOUND}</h2> */}
              <div className="publicationLogo">
                {publication_logo && (
                  <img
                    src={envConfig.PUBLICATION_LOGO_BASE_URL + publication_logo}
                    alt=""
                    srcset=""
                  />
                )}
              </div>
              <h2 className="publication">
                {escapeString(headline) || DATA_NOT_FOUND}
              </h2>
            </div>
            {isNewsDetailsMain && downloadParams && (
              <div className="d-flex nitRight">
                <div className="publicationLogo">
                  {publication_logo && (
                    <img
                      src={
                        envConfig.PUBLICATION_LOGO_BASE_URL + publication_logo
                      }
                      alt=""
                      srcset=""
                    />
                  )}
                </div>
                {isOnline && (
                  
                  <div>
                
                 <FacebookShareButton
                        url={isOnline?news.website_url:"#"}
                        title={isOnline?news.headline:news.content}
                        className="btn optionBtn">
                        <div className="hasTooltip">
                          <FacebookIcon size={32} round={true}/>
                          <span className="tooltipWrap center">Facebook Share</span>
                        </div>
                      </FacebookShareButton>
                <span>
               
                 <LinkedinShareButton
                        url={isOnline?news.website_url:"#"}
                        title={isOnline?news.headline:news.content}
                        className="btn optionBtn">
                        <div className="hasTooltip">
                          <LinkedinIcon size={32} round={true}/>
                          <span className="tooltipWrap center">Linkedin Share</span>
                        </div>
                      </LinkedinShareButton>
                      </span>
                 <span>
                  <TwitterShareButton
                        url={isOnline?news.website_url:"#"}
                        title={isOnline?news.headline:news.content}
                        className="btn optionBtn">
                        <div className="hasTooltip">
                          <TwitterIcon size={32} round={true}/>
                          <span className="tooltipWrap center">Twitter Share</span>
                        </div>
                      </TwitterShareButton>
               
                      </span> </div> ) }
                <div className="nitRightBtns">
                  {
                    <button className="btn optionBtn">
                      <div className="hasTooltip">
                        <ShareArticle
                          client_id={clientId}
                          article={shareParams}
                        />
                        <span className="tooltipWrap center">Share</span>
                      </div>
                    </button>
                  }
                  <div className="downloadBtnWithText optionBtn">
                    {
                      <div className="hasTooltip">
                        <DownloadFeeds
                          {...downloadParams}
                          hideText
                          hideFormats
                          publication_type_id={publication_type_id}
                          singleNews
                          articleInfoExtra={shareParams}
                          setIsLoading={setIsLoading}
                          isLoading={isLoading}
                        />
                        <span className="tooltipWrap center">Download</span>
                      </div>
                    }
                  </div>
                  {/* {isLoggedIn() ? (
                    <button className="btn optionBtn">
                      <FavoriteIcon />
                    </button>
                  ) : null} */}
                </div>
              </div>
            )}
          </div>
          {
            <div className="newsItemBottom">
              <div className="nibLeft">
                <span className="newsDate">
                  {publish_date || DATA_NOT_FOUND}
                </span>
              </div>
              {isLoggedIn() ? (
                <div className="nibRight">
                  <ul className="dropDownContainer">
                    {isOnline && news && (
                      <ArticleTags
                        article={news}
                        mediaType="online"
                        newsDetails={newsDetails}
                        showFavouriteTag
                        isPrintAndOnline
                        showTicket={true}
                        isOnline={true}
                      />
                    )}
                    {isPrint && news && (
                      <ArticleTags
                        newsDetails={newsDetails}
                        article={news}
                        mediaType="print"
                        showFavouriteTag
                        isPrintAndOnline
                        showTicket={true}
                        isPrint={true}
                      />
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
          }
        </div>
        {/* <h5 className="newsHeading">
          {escapeString(headline) || DATA_NOT_FOUND}
        </h5> */}

        {(!hide_metadata_details || hide_metadata_details != SHOW_DATA) && (
          <div className="newsItemList">
            {!newsDetails && (
              <>
                {renderEditionDetails()}
                <p>
                  <label>Source :</label>{" "}
                  <span>{source_name || DATA_NOT_FOUND}</span>
                </p>
                {showPageNo && (
                  <p>
                    <label>Page :</label>{" "}
                    <span>{page_no || DATA_NOT_FOUND}</span>
                  </p>
                )}
              </>
            )}
            {isPrint && newsDetails && renderPrintDetails()}
            {isOnline && newsDetails && renderOnlineDetails()}
          </div>
        )}
        <div className="imgContainer imageContainerWithPdf">
          {isPrint && newsDetails && !!showImages && (
            <>
              <div className="imagePdfbtnWrap">
                <ButtonGroup className="btn-group">
                  <Button
                    className={`${imgType === IMG ? "active" : ""} `}
                    onClick={() => setImageType(IMG)}
                  >
                    Image
                  </Button>
                  <Button
                    className={`${imgType === PDF ? "active" : ""} `}
                    onClick={() => setImageType(PDF)}
                  >
                    PDF
                  </Button>
                  <Button
                    className={`${imgType === TEXT ? "active" : ""} `}
                    onClick={() => setImageType(TEXT)}
                  >
                    Text
                  </Button>
                  {SUMMARY_ALLOWED_CLIENTS.includes(Number(clientId)) && updated_values?.length && updated_values[0].summary && updated_values[0].summary != ""?
                    <Button
                      className={`${imgType === SUMMERY ? "active" : ""} `}
                      onClick={() => setImageType(SUMMERY)}
                    >
                      Summary
                    </Button>
                    :""}
                </ButtonGroup>
              </div>
              {imgType === IMG && (
                <ImagePreview
                  imgSrcArray={articleImages.map((el) =>
                    formatImageUrl(el, true, false)
                  )}
                  handleImageZoom={handleImageZoom}
                  height={height}
                  width={width}
                />
              )}
              {imgType === PDF && (
                <PDFImageViewer
                  imgSrcArray={articleImages.map((el) =>
                    formatImageUrl(el, true, true)
                  )}
                />
              )}
              {imgType === TEXT && (
                SUMMARY_ALLOWED_CLIENTS.includes(Number(clientId))?
                <div id="newsContent" dangerouslySetInnerHTML={{
                  __html: escapeString(CONTENT,news.plain_matched_keyword),
                }}
          ></div>
          :<p id="newsContent">{`${escapeString(CONTENT)}`}</p>
              )}
              {SUMMARY_ALLOWED_CLIENTS.includes(Number(clientId)) && imgType === SUMMERY && (updated_values?.length && updated_values[0].summary && updated_values[0].summary != "") && (
                <p id="summaryContent">{`${updated_values[0].summary}`}</p>
              )}
            </>
          )}
        </div>
        {newsDetails && (
          <NextPrevArrows
            client_id={client_id}
            articleId={article_id}
            entity_id={entity_id}
            isPrint={isPrint}
            isOnline={isOnline}
            otherEdition={other_edition_url_html}
          />
        )}
      </div>
    </>
  );
}
